import { render } from "./YaRespondido.vue?vue&type=template&id=561a3c08"
const script = {}

import exportComponent from "/opt/build/repo/front-publico/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__